/* ══════════════════════════════════════════════════════════════════════
   MONTAGE · Menuekarten auf Hover oeffnen
   ══════════════════════════════════════════════════════════════════════
   Dawn oeffnet die Menuekarten per Klick auf das <summary>. Auf dem Desktop
   soll das Zeigen reichen. Getippt wird weiterhin nur da, wo es sein muss.

   Was hier bewusst NICHT passiert:

   · Kein Ersatz fuer Dawns HeaderMenu. Das Element bleibt zustaendig fuer
     focusout, fuer die Toggle-Animation und fuer die CSS-Variable
     --header-bottom-position-desktop. Hier wird ausschliesslich `open`
     gesetzt oder entfernt, den Rest erledigt Dawns `toggle`-Ereignis von
     selbst.

   · Kein Hover auf Touch. Die Regel prueft `hover: hover` und
     `pointer: fine`. Auf einem Tablet loest ein Tipp sonst zuerst ein
     Hover-Ereignis aus, die Karte oeffnet und schliesst im selben Moment.
     Unter 990 px greift ohnehin die Schublade.

   · Kein `preventDefault` auf Tastatur. Ein Mausklick auf ein bereits per
     Hover geoeffnetes Menue wuerde es zuklappen, das fuehlt sich kaputt an,
     deshalb wird er abgefangen. Die Tastatur muss aber weiter umschalten
     koennen: `event.detail` ist bei einem echten Mausklick groesser als 0
     und bei Enter oder Leertaste genau 0. Nur der Mausfall wird gestoppt.
   ══════════════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  var ABFRAGE = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  var VERZOEGERUNG = 160; // ms Nachlauf beim Verlassen

  var medien = window.matchMedia(ABFRAGE);
  var timer = null;

  function menues() {
    return document.querySelectorAll('.header__inline-menu header-menu');
  }

  function schliessen(menue) {
    var details = menue.querySelector('details');
    if (details && details.open) details.open = false;
  }

  function alleSchliessen(ausser) {
    menues().forEach(function (m) {
      if (m !== ausser) schliessen(m);
    });
  }

  function oeffnen(menue) {
    var details = menue.querySelector('details');
    if (!details) return;
    alleSchliessen(menue);
    if (!details.open) details.open = true;
  }

  function beiEintritt(event) {
    if (!medien.matches) return;
    window.clearTimeout(timer);
    oeffnen(event.currentTarget);
  }

  function beiAustritt(event) {
    if (!medien.matches) return;
    var menue = event.currentTarget;
    window.clearTimeout(timer);
    // Nachlauf, damit ein kurzer Ausschlag der Maus zwischen Beschriftung und
    // Karte sie nicht sofort zuklappt.
    timer = window.setTimeout(function () {
      schliessen(menue);
    }, VERZOEGERUNG);
  }

  function beiKlick(event) {
    // Nur der Mausklick auf ein offenes Menue wird geschluckt, siehe Kopf.
    if (!medien.matches) return;
    if (event.detail === 0) return;
    var details = event.currentTarget.closest('details');
    if (details && details.open) event.preventDefault();
  }

  function verdrahten() {
    menues().forEach(function (menue) {
      if (menue.dataset.mtHover === 'an') return;
      menue.dataset.mtHover = 'an';
      menue.addEventListener('mouseenter', beiEintritt);
      menue.addEventListener('mouseleave', beiAustritt);
      var summary = menue.querySelector('summary');
      if (summary) summary.addEventListener('click', beiKlick);
    });
  }

  function start() {
    verdrahten();

    // Zeiger verlaesst den Kopfbereich ganz: alles zu.
    var kopf = document.querySelector('.header-wrapper') || document.querySelector('.header');
    if (kopf && kopf.dataset.mtHover !== 'an') {
      kopf.dataset.mtHover = 'an';
      kopf.addEventListener('mouseleave', function () {
        if (!medien.matches) return;
        window.clearTimeout(timer);
        timer = window.setTimeout(function () {
          alleSchliessen(null);
        }, VERZOEGERUNG);
      });
    }
  }

  // Faellt die Abfrage weg, etwa beim Verkleinern des Fensters, bleibt sonst
  // eine Karte offen stehen.
  function beiWechsel() {
    if (!medien.matches) alleSchliessen(null);
  }
  if (medien.addEventListener) medien.addEventListener('change', beiWechsel);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Der Kopfbereich wird im Theme-Editor neu gerendert, dann sind die
  // Ereignisse weg. Shopify meldet das, also nochmal verdrahten.
  document.addEventListener('shopify:section:load', start);
})();
